// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__3Jytp","Icon":"NavigationItem_Icon__POda4","activeItem":"NavigationItem_activeItem__5b3Ho"};